import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {HoSoService} from '../../../../service/hoso/service-hoso';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import {HoSo} from '../../../../models/hoso/hoso';
import { ToastrService } from 'ngx-toastr';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {environment} from '../../../../../environments/environment';
import {EditHoSoDonViComponent} from './edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {CommandUtil} from '../../../../global/commandutil';
import {SelectFolderComponent} from '../../folder/select.component';
import {ShareHoSoComponent} from '../canhan/share.component';
import {DetailHoSoComponent} from '../canhan/detail.component';
import {XuLyDetailHoSoComponent} from './xulydetail.component';
import {YKTongHopHoSoComponent} from './tonghop.component';
import {RolePermissionService} from '../../../../service/security/service-rolepermission';
@Component({
  selector: 'app-views-info-hosodonvi',
  templateUrl: './donvi.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HoSoDonViComponent implements OnInit {
  @ViewChild(XuLyDetailHoSoComponent)
  public xuLyHoSoDetail: XuLyDetailHoSoComponent;
  private moduleName:  string = 'egov.info.hosodonvi';
  public language = language;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: HoSo[];
  public srTuKhoa: string = '';
  public status: number[] =[
    environment.hosodonvi
  ];
  public staffId: number = Sessioncommand.staffId;
  public nextId: number = 0;
  public hoSoId: number = 0;
  public showDetails: boolean = false;
  public permissionView: boolean = false;
  public permissionDetail: boolean = false;
  public permissionAdd: boolean = false;
  public permissionUpdate: boolean = false;
  public permissionDelete: boolean = false;
  public permissionToanQuyen: boolean = false;
  public permissionDownloadFile: boolean = false;
  public permissionYKienTongHop: boolean = false;
  public permissionShare: boolean = false;
  public permissionYKien: boolean = false;
  public permissionSaveDir: boolean = false;
  constructor( public hosoService: HoSoService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public commandUtil: CommandUtil,
               public rolePermissionService: RolePermissionService

  ) {
  }
  ngOnInit(): void {
    this.rolePermissionService.checkPermissionByModule(Sessioncommand.staffId, this.moduleName
    ).subscribe( x => {
      this.permissionView = x.findIndex(y => y.action === environment.view || y.action === environment.toanquyen) !== -1;
      if (this.permissionView)
      {
        this.search();
      }
      this.permissionAdd = x.findIndex(y => y.action === environment.add || y.action === environment.toanquyen) !== -1;
      this.permissionDetail = x.findIndex(y => y.action === environment.detail || y.action === environment.toanquyen) !== -1;
      this.permissionUpdate = x.findIndex(y => y.action === environment.update || y.action === environment.toanquyen) !== -1;
      this.permissionDelete = x.findIndex(y => y.action === environment.delete || y.action === environment.toanquyen) !== -1;
      this.permissionDownloadFile = x.findIndex(y => y.action === environment.download || y.action === environment.toanquyen) !== -1;
      this.permissionToanQuyen = x.findIndex(y => y.action === environment.toanquyen) !== -1;
      this.permissionYKienTongHop = x.findIndex(y => y.action === environment.ykientonghop || y.action === environment.toanquyen) !== -1;
      this.permissionShare = x.findIndex(y => y.action === environment.share || y.action === environment.toanquyen) !== -1;
      this.permissionYKien = x.findIndex(y => y.action === environment.ykien || y.action === environment.toanquyen) !== -1;
      this.permissionSaveDir = x.findIndex(y => y.action === environment.thumucluutru || y.action === environment.toanquyen) !== -1;
    });
    this.search();
  }
  public showConfirmationModal(id: number): void {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });

  }
  selectSave(id: number) {
    const modalEdit = this.bsModalService.show(ShareHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ShareHoSoComponent>modalEdit.content).edit(
      id
    );
    (<ShareHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {

      }
    });
  }
  saveFolder(id: number) {
    const modalEdit = this.bsModalService.show(SelectFolderComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<SelectFolderComponent>modalEdit.content).edit(
      id
    );
    (<SelectFolderComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {

      }
    });
  }
  edit(id: number) {
      const modalEdit = this.bsModalService.show(EditHoSoDonViComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
      (<EditHoSoDonViComponent>modalEdit.content).edit(
        id
      );
      (<EditHoSoDonViComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.search();

        }
      });

  }
  public detailXuLy(id: number) {
    if(this.permissionYKien)
    {
      this.hoSoId = id;
      this.nextId = this.dataList.findIndex( x => x.id === id);
      this.showDetails = true;
    }
  }
  public nextPage()
  {
    if( this.nextId + 1 >= this.dataList.length)
    {
      if(this.currentPage < this.numPages) {
        this.currentPage = this.currentPage + 1;
        this.hosoService.findAllByDonViPaging(this.srTuKhoa,  this.status.join(),-1, Sessioncommand.maDonVi, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.hoSoId = this.dataList[0].id;
            this.nextId = 0;
            this.xuLyHoSoDetail.edit(this.hoSoId);
          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId + 1;
      this.hoSoId = this.dataList [ this.nextId === this.dataList.length ? this.dataList.length -1 : this.nextId ].id;
      this.xuLyHoSoDetail.edit( this.hoSoId);
    }
  }
  public backPage()
  {
    if( this.nextId - 1  < 0)
    {
      if(this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
        this.hosoService.findAllByDonViPaging(this.srTuKhoa,  this.status.join(),-1, Sessioncommand.maDonVi, this.currentPage, this.maxSize).subscribe(dataList => {
          this.dataList = dataList;
          if (this.dataList.length > 0)
          {
            this.nextId = this.dataList.length - 1;
            this.hoSoId = this.dataList[this.nextId].id;
            this.xuLyHoSoDetail.edit(this.hoSoId);

          }
        });
      }
    }
    else
    {
      this.nextId = this.nextId  - 1;
      this.hoSoId = this.dataList [ this.nextId === -1 ? 0 : this.nextId].id;
      this.xuLyHoSoDetail.edit( this.hoSoId);
    }
  }
  yKienTongHop(id: number) {
    const modalEdit = this.bsModalService.show(YKTongHopHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<YKTongHopHoSoComponent>modalEdit.content).edit(
      id
    );
    (<YKTongHopHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });

  }
  detail(id: number) {
    const modalEdit = this.bsModalService.show(DetailHoSoComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DetailHoSoComponent>modalEdit.content).edit(
      id
    );
    (<DetailHoSoComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });
  }
  search()
  {

    this.hosoService.findAllByDonViPaging(this.srTuKhoa,  this.status.join(),-1, Sessioncommand.maDonVi, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.hosoService.getCountByDonVi(this.srTuKhoa, this.status.join(), -1, Sessioncommand.maDonVi).subscribe(recordCount => this.totalItems = recordCount);
  }
  deleteItem(id: number)
  {   this.hosoService.delete(id).subscribe({
        next: () => {
          this.toastr.success(language.delete_success_record, language.message);
          this.search();

        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }
}
